import React, { useLayoutEffect } from 'react'
import CommonInlineBody from 'common/components/entities/inline-body'
import { InlineBodyInterface } from 'common/types/inline-body-interface'
import { useBackgroundImage } from 'publisher/hooks/useBackgroundImage'
import BaseNodeChildren from '../ChildrenEntities'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'

interface InlineBodyProps {
  entity: InlineBodyInterface
}

const InlineBody = ({ entity }: InlineBodyProps) => {
  const { childIds = [] } = entity

  const {
    background,
    backgroundColor,
    mobileBackgroundColor,
    boxShadow,
    maxWidth,
    mobilePadding,
    mobileWidth,
    padding,
    width,
    blur,
    border,
    mobileBorder,
    mobileBoxShadow,
    mobileBackground,
  } = entity

  const {
    calculatedFontSize,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography()
  const {
    text: { paragraphTextColor: globalTextColor },
  } = useThemeColor()
  const { backgroundImage, mobileBackgroundImage } = useBackgroundImage({
    backgroundFileId: entity.backgroundFileId,
    mobileBackgroundFileId: entity.mobileBackgroundFileId,
  })

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      window.parent.postMessage(
        {
          sender: window.location.hash.slice(1), // iframe's hash
          width: '100%',
          height: document.getElementById('app')?.offsetHeight,
        },
        '*',
      )
    })

    resizeObserver.observe(document.body)
  }, [])

  return (
    <CommonInlineBody
      width={width}
      mobileWidth={mobileWidth}
      maxWidth={maxWidth}
      padding={padding}
      mobilePadding={mobilePadding}
      background={background}
      backgroundColor={backgroundColor}
      mobileBackgroundColor={mobileBackgroundColor}
      backgroundImage={backgroundImage}
      mobileBackgroundImage={mobileBackgroundImage}
      mobileBackground={mobileBackground}
      border={border}
      mobileBorder={mobileBorder}
      boxShadow={boxShadow}
      mobileBoxShadow={mobileBoxShadow}
      blur={blur}
      color={globalTextColor}
      fontFamily={calculatedFontFamily.desktop}
      fontSize={calculatedFontSize.desktop}
      mobileFontSize={calculatedFontSize.mobile}
    >
      <BaseNodeChildren childIds={childIds} />
    </CommonInlineBody>
  )
}

export default InlineBody
